import styled, { css } from 'styled-components';

import { WysiwygStyleWrapper } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, Components, FontFamily, FontSize,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

import {
  standardCheckboxInputStyles,
  standardCheckboxInteractionStyles,
  standardCheckboxLabelStyles,
} from '../../checkbox/styles';

const CPNT = Components.FORM_SILVERPOP;

export const StyledFormSilverpop = styled(WysiwygStyleWrapper)`
  max-width: 50%;
  width: 100%;

  ${Breakpoints.mobile(css`
    max-width: 100%;
  `)}


  table {
    width: 100%;
    margin-bottom: 15px;
  }

  .textInput {
    margin-bottom: 15px;
  }

  .checkbox_wrap,
  .checkbox-alt {
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding-top: 5px;
    padding-bottom: 5px;
    ${standardCheckboxInteractionStyles}
  }

  .checkbox_label {
    margin-left: 10px;
  }

  fieldset._form-fieldset {
    border: none;
    margin: 0 0 20px;
    padding: 0;
  }

  fieldset._form-fieldset legend._form-label {
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG40, undefined, undefined)};
    display: block;
    margin-bottom: 12px;
    padding: 0;
    text-align: left;
  }

  .checkbox-alt input[type="checkbox"] {
    ${standardCheckboxInputStyles}
  }

  .checkbox-alt label {
    ${standardCheckboxLabelStyles}
  }

  .form-control {
    display: block;
    width: 100%;
    height: auto;
    padding: 10px 15px;
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG50, undefined, undefined)};
    line-height: 1.25;
    color: #55595c;
    background-color: white;
    background-image: none;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    margin-bottom: 15px;
  }

  .fieldLabel, .sectionHeader {
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG40, undefined, undefined)};
    padding-bottom: 10px;
    text-align: left;
  }

  p {
    text-align: left;
  }

  p:has(> input[type="hidden"]):not(:has(> :not(input[type="hidden"]))) {
    margin: 0;
    padding: 0;
  }

  .form-button {
    border: none;
    padding: 15px 20px;
    ${() => getFontStyles(FontFamily.SECONDARY_FONT, undefined, undefined, undefined)};
    color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, colorProfile)};
    background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, colorProfile)};

    &:hover {
      color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, colorProfile)};
      background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, colorProfile)};
    }
  }

  ._field_captcha {
    margin-bottom: 15px;
  }
`;
